import { useContext } from "react"
import { ModalContext, ModalIds } from "@contexts/ModalContext";

export default function useModal() {
    const { setModalId, setShowModal, modalId, showModal, setData } = useContext(ModalContext)

    const openModal = (modalId: ModalIds, data?: any) => {
        setShowModal(true)
        setModalId(modalId)
        setData(data)
    }

    const closeModal = () => {
        setShowModal(false)
        setModalId(undefined)
        setData(undefined)
    }

    return {
        closeModal,
        openModal,
        showModal,
        modalId
    }
}